const sortAssignments = (data: any) => {
  data.sort((a: any, b: any) => {
    if (a.drivers[0].catalog < b.drivers[0].catalog) return -1;
    if (a.drivers[0].catalog > b.drivers[0].catalog) return 1;

    // Ahora se compara por 'number'
    const numberA = parseInt(a.drivers[0].number, 10);
    const numberB = parseInt(b.drivers[0].number, 10);

    const isNumberA = !isNaN(numberA);
    const isNumberB = !isNaN(numberB);

    if (isNumberA && isNumberB) return numberA - numberB;
    else if (isNumberA) return -1;
    else if (isNumberB) return 1;
    else return 0;
  });
};

const getTeamLogo = (team_id: number | string, logo: string | null) => {
  if (logo == null) return team_id;
  else return `${team_id}_${logo}`;
};

const getRandomReportMessage = (flag: string, name: string, link: string) => {
  const messages = [
    `Deep race analysis and full results from ${flag} ${name}: ${link}`,
    `In-depth breakdown of the race plus full results from ${flag} ${name}: ${link}`,
    `Full race analysis, strategy review, and results from ${flag} ${name}: ${link}`,
    `Detailed analysis of the Grand Prix alongside complete race results from ${flag} ${name}: ${link}`,
    `${flag} ${name} breakdown — key moments, strategy analysis, and full results: ${link}`,
    `Comprehensive race analysis and results from ${flag} ${name}: ${link}`,
    `Full post-race analysis, insights, and results from ${flag} ${name}: ${link}`,
    `Everything from ${flag} ${name}: strategy analysis, key battles, and full results: ${link}`,
  ];
  return messages[Math.floor(Math.random() * messages.length)];
};

const getRallyTeamName = (name: string, class_name: string | null): string => {
  if (!class_name || class_name === "") return name;
  let processedClassName = class_name;
  if (/group/i.test(class_name)) {
    const match = class_name.match(/group\s*([a-z0-9])/i);
    if (match && match[1]) {
      processedClassName = `${class_name} grp${match[1]}`;
    }
  }

  // 1. Limpiamos y separamos las palabras clave de la clase (ej: "GROUP R2" -> ["group", "r2"])
  // Filtramos palabras muy cortas opcionalmente, o las dejamos si importan (como "R2")
  const classWords = processedClassName
    .toLowerCase()
    .split(/\s+/)
    .filter((word) => word.length > 0);

  if (classWords.length === 0) return name;

  // 2. Buscamos cuál de las palabras de la clase (ej: "r2") aparece primero dentro del name
  let cutIndex = name.length;
  let matchedWord = "";

  for (const word of classWords) {
    // Creamos una regex para encontrar la palabra como token independiente o parte de un código (ej: R2, R2003, etc.)
    // Usamos '\b' para límites de palabra o buscamos si está presente de forma aislada/adyacente
    const escapedWord = word.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    const regex = new RegExp(`\\b${escapedWord}\\b`, "i");
    const match = name.search(regex);

    // Si encuentra la palabra y aparece antes que cualquier otra coincidencia previa
    if (match !== -1 && match < cutIndex) {
      cutIndex = match;
      matchedWord = word;
    }
  }

  // Si encontramos una coincidencia, cortamos el string justo antes de esa palabra
  if (cutIndex < name.length) {
    return name.substring(0, cutIndex).trim();
  }

  // 3. Plan B: Si no hubo coincidencia exacta de palabra completa (ej: "R2" dentro de "WRC2003"),
  // probamos buscando la subcadena principal de la clase.
  const firstSignificantWord =
    classWords.find((w) => w.length >= 2) || classWords[0];
  const escapedFallback = firstSignificantWord.replace(
    /[-\/\\^$*+?.()|[\]{}]/g,
    "\\$&",
  );
  const fallbackRegex = new RegExp(`\\s*${escapedFallback}.*`, "i");

  return name.replace(fallbackRegex, "").trim();
};

export {
  sortAssignments,
  getTeamLogo,
  getRandomReportMessage,
  getRallyTeamName,
};
